import React, { useEffect, useState } from "react";
import app from "./../../firebase/firebase";
import { withRouter, Redirect } from "react-router";
import axios from "axios";
import jsonwebtoken from "jsonwebtoken";
import Toastify from 'toastify-js'

export const AuthContext = React.createContext();

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);

  useEffect(() => {
    const isAuth = sessionStorage.getItem("isAuth");
    const storagedToken = sessionStorage.getItem("storagedToken");

    if (isAuth && storagedToken) {
        setCurrentUser(storagedToken)
    }
  }, []);

  return (
    <AuthContext.Provider
      value={{
        currentUser
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const Reload = () => {
    // window.location.reload(true);
    window.location.href = '/';
}